/* eslint-disable class-methods-use-this */
import { getAuthTokenFromLocalStorage } from '../helper';
import { authHttp } from './BaseRequest';

export const AUTH_TYPES = {
  LOGIN: 'login',
  GUEST: 'guest',
  COOKIE: 'cookie',
  TP_TOKEN: 'tpToken',
};

export type TAuthType = typeof AUTH_TYPES[keyof typeof AUTH_TYPES];

export interface IGetPasswordToken {
  // eslint-disable-next-line camelcase
  auth_type: TAuthType;
  // eslint-disable-next-line camelcase
  username?: string;
  // eslint-disable-next-line camelcase
  password?: string;
  // eslint-disable-next-line camelcase
  auth_token?: string;
  // eslint-disable-next-line camelcase
  user_id?: string;
}

class AuthServiceHelper {
  getPasswordToken(data: IGetPasswordToken) {
    const params = new URLSearchParams();

    params.append('grant_type', 'password');
    params.append(
      'client_id',
      process.env.REACT_APP_TUTOPIYA_CLIENT_ID as string
    );

    params.append(
      'client_secret',
      process.env.REACT_APP_TUTOPIYA_CLIENT_SECRET as string
    );

    if (data.auth_type === AUTH_TYPES.TP_TOKEN) {
      if (!data.auth_token || !data.user_id) return undefined;

      params.append('username', `${data.auth_type}_${data.user_id}`);
      params.append('password', data.auth_token);
    } else if (data.auth_type === AUTH_TYPES.GUEST) {
      params.append('username', data.auth_type);
    } else if (data.auth_type === AUTH_TYPES.COOKIE) {
      if (!data.user_id) return undefined;

      params.append('username', `${data.auth_type}_${data.user_id}`);
    } else {
      if (!data.username || !data.password) return undefined;

      params.append('username', `${data.auth_type}_${data.username}`);
      params.append('password', data.password);
    }

    return authHttp
      .post('/oauth/token', params)
      .then((res) => res.data)
      .catch((err) => {
        return Promise.reject(new Error(JSON.stringify(err.response)));
      });
  }

  getClientCredentialToken() {
    const params = new URLSearchParams();

    params.append('grant_type', 'client_credentials');
    params.append(
      'client_id',
      process.env.REACT_APP_TUTOPIYA_CLIENT_ID as string
    );

    params.append(
      'client_secret',
      process.env.REACT_APP_TUTOPIYA_CLIENT_SECRET as string
    );

    return authHttp.post('/oauth/token', params).then((res) => res.data);
  }
}

export default new AuthServiceHelper();
